module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_down_24px.f5b7dcac.svg";